<template>
    <div id="container" type="vdpp">
        <div class="page page-agenthome" v-ga:page="{pageType: glb.pageType, glb: glb}" v-ga:request="{pageType:'vagenthome'}">
            <mvtHeader />
            <mvtWelcome>
                <template v-slot:img>
                    <img :src="glb.cdnUrl + 'vimages/agent-welcome.webp'" alt="Welcome Movoto Agent Home" fetchpriority="auto"/>
                </template>
                <template v-slot:content>
                    <h1 class="f0 text-bold">Connect with a top rated local agent</h1>
                    <div class="f5">Get matched with a skilled local agent who will guide you through your real estate journey.</div>
                    <a href="javascript:;" @click="openHotlead" class="btn secondary regular">Connect with a Top Agent</a>
                </template>
            </mvtWelcome>
            <agentBar></agentBar>
            <section id="topAgent" class="inline large">
                <div class="grid gap-3 sm-grid-cols-1 md-grid-cols-3 fixed fixed-max-sm">
                    <h2 class="wrap text-center"><b class="f3 text-bold">Learn more about our top-rated local agents</b></h2>
                    <div class="large inline flex vertical left bg-default corner outline text-center">
                        <div><span class="f1 circle large default disabled icon-house"></span></div>
                        <div><b class="f4">Top-Rated Local Agents</b></div>
                        <div class="body">Partner with a Top-Rated local agent, with an average of 7+ years of experience, and ranked among the top 1% in the the Industry.</div>
                    </div>
                    <div class="large inline flex vertical left bg-default corner outline text-center">
                        <div><span class="f1 circle large default disabled icon-open-house"></span>
                        </div>
                        <div><b class="f4"> Exclusive Access To Listings</b></div>
                        <div class="body">Gain Access to exclusive off-market properties, providing you with a unique edge in your property search.</div>
                    </div>
                    <div class="large inline flex vertical left bg-default corner outline text-center">
                        <div><span class="f1 circle large default disabled icon-user"></span></div>
                        <div><b class="f4">Agents From The Best Brokerages</b></div>
                        <div class="body"> The best local agents from the most trusted brokerages near you, including Coldwell Banker, Keller Williams, Compass, Better Homes and Gardens, EXP, Century 21, RE/MAX, and more.</div>
                    </div>
                </div>
            </section>
            <agentTips class="bg-default inline large" id="agentTipsPanel"></agentTips>
            <agentWorkflow id="agentProcessPanel"></agentWorkflow>
            <agentBanner class="inline bg-default large"></agentBanner>
            <section class="inline large" id="agentFaqPanel">
                <div class="grid gap-3 fixed fixed-max-sm top xs-grid-cols-1">
                    <div class="wrap text-center">
                        <h2 class="f3 text-bold">Frequently Asked Questions</h2>
                    </div>
                    <mvtFaq :query="faqQuery"></mvtFaq>
                </div>
            </section>
            <section class="inline large">
                <div class="grid gap-3 fixed fixed-max-sm top xs-grid-cols-1">
                    <agentConnect></agentConnect>
                </div>
            </section>
            <agentTourlink class="inline large bg-default"  id="agentToolLinkPanel"></agentTourlink>

            <agentBrokerage class="inline large" :showAll="true" id="agentBrokeragePanel"></agentBrokerage>
            <brokerageBanner class="inline large bg-default"></brokerageBanner>
            <section class="inline large">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
                    <div class="wrap">
                        <h2 class="text-bold f3 text-capitalize">We're Licensed in the Following States</h2>
                    </div>
                    <div class="grid gap-1 fixed top xs-grid-cols-1 sm-grid-cols-2">
                        <div><b>Alabama: </b><span>License#95485</span></div>
                        <div><b>Alaska: </b><span>License#18503</span></div>
                        <div><b>Arizona: </b><span>License#BR522072000</span></div>
                        <div><b>Arkansas: </b><span>License#PB00073784</span></div>
                        <div><b>California: </b><span>1900 S. Norfolk #310 San Mateo, CA 94403<br/>License#1517281</span></div>
                        <div><b>Colorado: </b><span>License#ER40012120</span></div>
                        <div><b>Connecticut: </b><span><span class="text-bold">Movoto Connecticut, LLC: </span>License#REB.0790074</span></div>
                        <div><b>Delaware: </b><span>License#RB-0020283</span></div>
                        <div><b>Florida: </b><span>License#BK3215765</span></div>
                        <div><b>Georgia: </b><span>License#81776</span></div>
                        <div><b>Hawaii: </b><span>License#RB19236</span></div>
                        <div><b>Idaho: </b><span>License#DB28686</span></div>
                        <div><b>Illinois: </b><span>License#471016985</span></div>
                        <div><b>Indiana: </b><span>License#PB21300092</span></div>
                        <div><b>Iowa: </b><span>License#B61881000</span></div>
                        <div><b>Kansas: </b><span>License#BR00041664</span></div>
                        <div><b>Kentucky: </b><span>License#72519</span></div>
                        <div><b>Louisiana: </b><span>License#BROK.0995680615-ACT</span></div>
                        <div><b>Maine: </b><span>License#DB916719</span></div>
                        <div><b>Maryland: </b><span>License#5548</span></div>
                        <div><b>Massachusetts: </b><span>License#129948</span></div>
                        <div><b>Michigan: </b><span>License#6502359839</span></div>
                        <div><b>Minnesota: </b><span>License#40173276</span></div>
                        <div><b>Mississippi: </b><span>License#20646</span></div>
                        <div><b>Missouri: </b><span>License#2013029832</span></div>
                        <div><b>Montana: </b><span>License#RRE-BRO-LIC-12492</span></div>
                        <div><b>Nebraska: </b><span>License#20120633</span></div>
                        <div><b>Nevada: </b><span>License#B.0009586.INDV</span></div>
                        <div><b>New Jersey: </b><span>License#9483896</span></div>
                        <div><b>New Mexico: </b><span>License#19031</span></div>
                        <div><b>New York: </b><span>License#10311201019</span></div>
                        <div><b>North Carolina: </b><span>License#235093</span></div>
                        <div><b>North Dakota: </b><span>License#9127</span></div>
                        <div><b>Ohio: </b><span>License#BRK.2004017062</span></div>
                        <div><b>Oklahoma: </b><span>License#141663</span></div>
                        <div><b>Oregon: </b><span>License#860300251</span></div>
                        <div><b>Pennsylvania: </b><span>License#RM421267</span></div>
                        <div><b>Rhode Island: </b><span>License#REC.0016244</span></div>
                        <div><b>South Carolina: </b><span>License#5932</span></div>
                        <div><b>South Dakota: </b><span>License#15349</span></div>
                        <div><b>Tennessee: </b><span>License#279391</span></div>
                        <div><b>Texas: </b><span>License#372106</span></div>
                        <div><b>Utah: </b><span>License#5462116-PB00</span></div>
                        <div><b>Vermont: </b><span>License#81.0090524</span></div>
                        <div><b>Virginia: </b><span>License#225192650</span></div>
                        <div><b>Washington: </b><span>License#46613-90</span></div>
                        <div><b>West Virginia: </b><span>License#WV0028853</span></div>
                        <div><b>Wisconsin: </b><span>License#50361</span></div>
                        <div><b>Wyoming: </b><span>License#212100</span></div>
                    </div>
                </div>
            </section>
            <mvtFooter />
            <mvtPopSignin />
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>
<script src="./page-agenthome.js"></script>
<style lang="scss">
@use "./page-agenthome.scss" as *;
</style>